import { ThemeColor } from "./models";

const themecolors: ThemeColor[] = [
    {
        variable: '$Primary',
        value: ''
    }
]

export default themecolors;